export enum LANG {
  UA = 'UA',
}

export const LANG_DEFAULT = LANG.UA;

export const LANG_SUPPORTED = [LANG.UA];

export const COOKIE_LANG = 'COOKIE_LANG';
